module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-checklists/master-register-checklists.component.scss
// module id = ./src/app/master/master-register-checklists/master-register-checklists.component.scss
// module chunks = main